<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-card class="lighten-4 pa-3" dark color="rgba(29,27,65,.6)" style="height:100%;">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-radio-group row :hide-details="true" v-model="graphSelected" class="mt-0" dense>
          <v-radio label="Cases" value="cases" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Daily Increase" value="daily" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Daily % Change" value="dailyperc" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Most Daily New Cases" value="newcases" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Most Confirmed By Population" value="confirmedpop" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Most Known Testing" value="testing" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Most Deaths By Population" value="deathspop" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Least Hospital Beds By Population" value="bedspop" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Countries Comparison" value="comparison" color="pink" style="font-weight: 300;"></v-radio>
          <v-radio label="Peak Analysis" value="peaks" color="pink" style="font-weight: 300;"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <Cases v-show="graphSelected === 'cases'" ref="Cases"></Cases>
        <Daily v-show="graphSelected === 'daily'" ref="Daily"></Daily>
        <DailyPercentage v-show="graphSelected === 'dailyperc'" ref="DailyPercentage"></DailyPercentage>
        <NewCases v-show="graphSelected === 'newcases'" ref="NewCases"></NewCases>
        <ConfirmedPopulation v-show="graphSelected === 'confirmedpop'" ref="ConfirmedPopulation"></ConfirmedPopulation>
        <DeathsPopulation v-show="graphSelected === 'deathspop'" ref="DeathsPopulation"></DeathsPopulation>
        <BedsPopulation v-show="graphSelected === 'bedspop'" ref="BedsPopulation"></BedsPopulation>
        <Testing v-show="graphSelected === 'testing'" ref="Testing"></Testing>
        <TopCountries v-show="graphSelected === 'comparison'" ref="TopCountries"></TopCountries>
        <Peaks v-show="graphSelected === 'peaks'" ref="Peaks"></Peaks>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Cases from "@/components/africa/graphs/Cases.vue";
import Daily from "@/components/africa/graphs/Daily.vue";
import DailyPercentage from "@/components/africa/graphs/DailyPercentage.vue";
import NewCases from "@/components/africa/graphs/NewCases.vue";
import ConfirmedPopulation from "@/components/africa/graphs/ConfirmedPopulation.vue";
import DeathsPopulation from "@/components/africa/graphs/DeathsPopulation.vue";
import BedsPopulation from "@/components/africa/graphs/BedsPopulation.vue";
import Testing from "@/components/africa/graphs/Testing.vue";
import TopCountries from "@/components/africa/graphs/TopCountries.vue";
import Peaks from "@/components/africa/graphs/Peaks.vue";

export default {
  name: "Graph",
  components: {
    Cases,
    Daily,
    NewCases,
    ConfirmedPopulation,
    DeathsPopulation,
    BedsPopulation,
    Testing,
    TopCountries,
    DailyPercentage,
    Peaks
  },
  data: () => ({
    casesData: [],
    allData: [],
    graphSelected: "cases",
    countrySelected: ""
  }),
  watch: {
    graphSelected: function(val) {
      //resize the graphs
      if (val === "cases") {
        //load the graph data
        this.$refs.Cases.loadCases(
          this.casesData,
          this.countrySelected
        );
        
        this.$refs.Cases.resize();
      }
      else if (val === "daily") {
        //load the graph data
        this.$refs.Daily.loadCases(
          this.casesData,
          this.countrySelected
        );
        
        this.$refs.Daily.resize();
      }
      else if (val === "dailyperc") {
        //load the graph data
        this.$refs.DailyPercentage.loadCases(
          this.casesData,
          this.countrySelected
        );
        
        this.$refs.DailyPercentage.resize();
      }
      else if (val === "newcases") {
        //load the graph data
        this.$refs.NewCases.loadCases(
          this.allData,
          this.countrySelected
        );
        
        this.$refs.NewCases.resize();
      }
      else if (val === "confirmedpop") {
        //load the graph data
        this.$refs.ConfirmedPopulation.loadCases(
          this.allData,
          this.countrySelected
        );
        
        this.$refs.ConfirmedPopulation.resize();
      }
      else if (val === "deathspop") {
        //load the graph data
        this.$refs.DeathsPopulation.loadCases(
          this.allData,
          this.countrySelected
        );
        
        this.$refs.DeathsPopulation.resize();
      }
      else if (val === "bedspop") {
        //load the graph data
        this.$refs.BedsPopulation.loadCases(
          this.allData,
          this.countrySelected
        );
        
        this.$refs.BedsPopulation.resize();
      }
      else if (val === "testing") {
        //load the graph data
        this.$refs.Testing.loadCases(
          this.allData,
          this.countrySelected
        );
        
        this.$refs.Testing.resize();
      }
      else if (val === "comparison") {
        //load the graph data
        this.$refs.TopCountries.loadCases(
          this.allData,
          this.countrySelected
        );
        
        this.$refs.TopCountries.resize();
      }
      else if (val === "peaks") {
        //load the graph data
        this.$refs.Peaks.loadCases(
          this.casesData,
          this.countrySelected
        );
        
        this.$refs.Peaks.resize();
      }


      //post the GA
      gtag("event", "graph", {
        event_category: val,
        'send_to': 'UA-161523063-2'
      });
    }
  },
  methods: {
    loadCases(data, countryDisplay) {

      //if africa selected then store all data
      if(!countryDisplay || countryDisplay === "") {
        this.allData = data
      }

      this.casesData = data;
      this.countrySelected = countryDisplay;

      //load the graph data
      if (this.graphSelected === "cases") {
        this.$refs.Cases.loadCases(
          this.casesData,
          this.countrySelected
        );
      }
      else if (this.graphSelected === "daily") {
        this.$refs.Daily.loadCases(
          this.casesData,
          this.countrySelected
        );
      }  
      else if (this.graphSelected === "dailyperc") {
        this.$refs.DailyPercentage.loadCases(
          this.casesData,
          this.countrySelected
        );
      }      
      else if (this.graphSelected === "newcases") {
        this.$refs.NewCases.loadCases(
          this.allData,
          this.countrySelected
        );
      }     
      else if (this.graphSelected === "confirmedpop") {
        this.$refs.ConfirmedPopulation.loadCases(
          this.allData,
          this.countrySelected
        );
      }    
      else if (this.graphSelected === "deathspop") {
        this.$refs.DeathsPopulation.loadCases(
          this.allData,
          this.countrySelected
        );
      }  
      else if (this.graphSelected === "bedspop") {
        this.$refs.BedsPopulation.loadCases(
          this.allData,
          this.countrySelected
        );
      }  
      else if (this.graphSelected === "testing") {
        this.$refs.Testing.loadCases(
          this.allData,
          this.countrySelected
        );
      }  
      else if (this.graphSelected === "comparison") {
        this.$refs.TopCountries.loadCases(
          this.allData,
          this.countrySelected
        );
      }
      else if (this.graphSelected === "peaks") {
        this.$refs.Peaks.loadCases(
          this.casesData,
          this.countrySelected
        );
      }
      
      var self = this
      setTimeout(function() {
        self.$emit("resize")
      }, 5000)    
      
    }
  }
};
</script>
